import { call, put, select, takeEvery } from 'redux-saga/effects';
import CONFIG from '../../config';
import { requestLanguageSucceeded } from '../actions';
import {
  httpRequestFailed,
  httpRequestStarted,
  httpRequestSucceeded
} from '../app-communication/actions/http-requests';
import { REQUEST_TRANSLATIONS } from '../constants';

export const fetchI18N = ({ fileName }) => {
  const url = `${CONFIG.TRANSLATIONS_HOST}/${fileName}.json`;

  return fetch(url)
    .catch((error) => {
      throw Error('An error occurred. Please try again later');
    })
    .then((response) => {
      if (!response.ok && response.status !== 422) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => json);
};

function* loadTranslations(action) {
  yield put(httpRequestStarted(action));

  try {
    const { chatSession } = yield select();
    const lang = chatSession.language || 'en';
    const response = yield call(fetchI18N, { fileName: lang });

    yield put(requestLanguageSucceeded({ locale: lang, messages: response }));

    yield put(httpRequestSucceeded(action, response));

    return response; // TODO if there is error in the translation request the chat is not working
  } catch (e) {
    yield put(httpRequestFailed(action, e));
    console.error(e);
  }
}

export default function* () {
  yield takeEvery(REQUEST_TRANSLATIONS, loadTranslations);
}
